/**
* スライダー
*/

import Splide from '@splidejs/splide';
// CSSは functions/html_head.php で読み込み

export default class Slider {
  constructor(_parm) {
    this.arrayElmsSplide = [...document.querySelectorAll('.splide')];
    if (!this.arrayElmsSplide.length) return;
  }

  init() {
    if (!this.arrayElmsSplide.length) return;
    this.arrayElmsSplide.forEach(_elmSplide => {
      new Splide(_elmSplide, {
        type: 'slide',
        arrows: false,
        pagination: true,
        perPage: 2,
        gap: 69,
        breakpoints: {
          767: {
            perPage: 1,
            gap: 20,
          },
        }
      }).mount();
    });
  }
}